import { render } from "./electronicChannelFinancial.vue?vue&type=template&id=84d16a46&scoped=true"
import script from "./electronicChannelFinancial.vue?vue&type=script&lang=js"
export * from "./electronicChannelFinancial.vue?vue&type=script&lang=js"

import "./electronicChannelFinancial.vue?vue&type=style&index=0&id=84d16a46&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d16a46"]])

export default __exports__